import { useNavigate, useParams } from "react-router-dom";
import useCrudForm from "../../../../hooks/useCrudForm";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/useTypedSelector";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { UserModel } from "../../../auth/domain/models/userModel";
import { LayoutModal } from "../../../general/modules/commons/layoutModal/layoutModal";
import { connectUserRelation } from "../../infrastructure/slices/RelationSlice";
import { userRelationFormSchema } from "../../../user/domain/schemas/userSchema";
import { UserMutateFormTemplate } from "../../../user/modules/commons/templates/userMutateFormTemplate";
import { toast } from "sonner";
import { UserMutateInputs } from "../../../user/modules/pages/UserMutatePage";

export const RelationUserMutateModal = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const { employeeId, id } = useParams();
  const currentUser = useAppSelector((state) => state.auth.user);

  const model = useAppSelector((state) => state.crudMutate).model as UserModel;
  const dispatch = useAppDispatch();

  const crud = useCrudForm({
    schema: userRelationFormSchema,
    prefix: "users",
    createMutation: "upsertUser",
    updateMutation: "upsertUser",
    formTemplate: UserMutateFormTemplate,
    id: employeeId ? parseInt(employeeId) : undefined,
    onBeforeSubmit: (data) => {
      const mutateData = data as UserMutateInputs;

      if (mutateData.password || mutateData.password_confirmation) {
        if (mutateData.password !== mutateData.password_confirmation) {
          toast.error(t("Passwords do not match"));
          return { validationError: "Passwords do not match" };
        }
      }

      if (mutateData.roles == null) {
        const role = currentUser.availableRoles.find(
          (role) => role === "dealer-employee",
        );
        if (role) {
          mutateData.roles = { name: role };
        }
      } else {
        if (Array.isArray(mutateData.roles)) {
          mutateData.roles = { name: mutateData.roles[0].name };
        }
      }

      if (mutateData.status == null) {
        mutateData.status = true;
      }

      if (!mutateData.name) {
        mutateData.name = mutateData.username;
      }

      return mutateData;
    },
    onAfterSubmit: (result) => {
      const user = result as UserModel;
      if (user.id) {
        void dispatch(
          connectUserRelation({
            userId: user.id,
            relationId: parseInt(id ?? ""),
          }),
        ).then(() => {
          navigate(-1);
        });
      } else {
        navigate(-1);
      }
    },
    queryExclude: ["password", "relation_id", "password_confirmation"],
    mutationExclude: ["availableRoles", "password_confirmation"],
  });

  const title = model.id
    ? t("relation.employee.mutate.edit", { name: model.name })
    : t("relation.employee.mutate.add", { name: model.name });

  return (
    <LayoutModal
      title={title}
      show={true}
      onHide={() => navigate(-1)}
      actions={<Button onClick={() => crud.submit()}>{t("Save")}</Button>}
    >
      {crud.form}
    </LayoutModal>
  );
};
